import PasswordReset from 'components/Auth';
import PasswordRequest from 'components/Auth/request';
import PasswordSet from 'components/Auth/set';
import Login from 'components/Login/Login';
import NotFound from 'components/NotFound';
import AdminPasswordReset from 'components/admin/pages/ResetPassword';
import AdminPasswordRequest from 'components/admin/pages/ResetPassword/request';
import AdminPasswordSet from 'components/admin/pages/ResetPassword/set';
import Logout from 'components/shared/Logout/Logout';

const AUTHENTICATION = [
  {
    path: 'admin/login',
    element: <Login />
  },
  {
    path: 'password/*',
    element: <PasswordReset />,
    children: [
      {
        path: 'request',
        element: <PasswordRequest />
      },
      {
        path: 'reset/:token',
        element: <PasswordSet />
      },
      {
        path: '*',
        element: <NotFound portal="password/request" />
      }
    ]
  },
  {
    path: 'admin/password/*',
    element: <AdminPasswordReset />,
    children: [
      {
        path: 'request',
        element: <AdminPasswordRequest />
      },
      {
        path: 'reset/:token',
        element: <AdminPasswordSet />
      },
      {
        path: '*',
        element: <NotFound portal="admin" />
      }
    ]
  },
  {
    path: 'login',
    element: <Login loginType="user" />
  },
  {
    path: 'logout',
    element: <Logout />
  }
];

export default AUTHENTICATION;
